import React, { useEffect, useState } from 'react'
import Script from 'next/script'
import { Headline } from '~/elements/Headline/Headline'
import { useTranslation } from 'next-i18next'
import { initReviews } from './lib/reviewsWidgetInitializer'
import { useRouter } from 'next/router'
import { createLanguageRegionLocale } from '~/lib/createLanguageRegionLocale'
import { DEFAULT_LOCALE } from '~/config/constants'

type Props = {
  relatedSkus: string[]
}

const ReviewsWidget: React.FC<Props> = ({ relatedSkus }) => {
  const router = useRouter()
  const { t } = useTranslation()
  const [reviewsScriptLoaded, setReviewScriptLoaded] = useState(false)
  const finalLocale = router.locale ? createLanguageRegionLocale(router.locale) : DEFAULT_LOCALE

  useEffect(() => {
    if (reviewsScriptLoaded) {
      initReviews(relatedSkus, finalLocale, {
        verifiedCustomer: t('Verified Customer'),
      })
    }
  }, [reviewsScriptLoaded, relatedSkus, t, finalLocale])

  return (
    <div className="relative max-w-[100vw] px-4 pt-8 pb-6 lg:px-20 lg:pt-16 lg:pb-8">
      <div id="recommendations" className="absolute -top-36" role="none" />
      <Headline type="h2" styleAs="slider" className="mb-8">
        {t('Client Reviews')}
      </Headline>
      <div>
        <div id="ReviewsWidget" />
        <Script
          id="ruk-reviews-widget-script"
          strategy="lazyOnload"
          src="https://widget.reviews.io/polaris/build.js"
          onReady={() => setReviewScriptLoaded(true)}
        />
      </div>
    </div>
  )
}

export default React.memo(ReviewsWidget)
